import { normalizeString } from "@modules/formatValues";
import Link from "next/link";

export function NavbarItem({ icon, desc, descSize, descColor, src, currentLocation }) {

    const extractFirstWord = (url) => {
        const match = url.match(/https?:\/\/[^\/]+\/([^\/]+)/);
        return match ? match[1] : "";
    };

    const firstWord = normalizeString(extractFirstWord(currentLocation || ""));
    const normalizedSrc = normalizeString(src);
    const activeClass = firstWord === normalizedSrc ? "bg-white/20 font-semibold" : "";

    return (
        <Link href={src} className={`group my-1 flex w-full cursor-pointer items-center gap-5 border-b border-white/40 p-2 last:border-b-0 sm:flex-col sm:gap-2 sm:border-none ${activeClass} rounded-md`}>
            {icon}
            <p className={`${descSize} ${descColor} text-center sm:hidden lg:block group-hover:lg:font-semibold`}>{desc}</p>
        </Link>
    )
}